import { localizedChannel } from "../../intl/shared-resources/channel.js";
import { ChipVariant, ChipType } from "../../components/chip/types.js";
import { Channel } from "../../contract/pam.js";
const getChannelChipsMapping = () => ({
  [Channel.P2P]: {
    label: localizedChannel[Channel.P2P],
    chipType: ChipType.Tag,
    chipVariant: ChipVariant.DropdownDefault
  },
  [Channel.Official]: {
    label: localizedChannel[Channel.Official],
    chipType: ChipType.Tag,
    chipVariant: ChipVariant.DropdownDefault
  },
  [Channel.None]: {
    label: localizedChannel[Channel.None],
    chipType: ChipType.Tag,
    chipVariant: ChipVariant.DropdownDefault
  }
});
export {
  getChannelChipsMapping
};
//# sourceMappingURL=channelConfig.js.map
